import { render } from "./NewFromWorkshopTemplate.vue?vue&type=template&id=b3968b3a"
import script from "./NewFromWorkshopTemplate.vue?vue&type=script&lang=js"
export * from "./NewFromWorkshopTemplate.vue?vue&type=script&lang=js"

import "./NewFromWorkshopTemplate.vue?vue&type=style&index=0&id=b3968b3a&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__